// extracted by mini-css-extract-plugin
export var container = "_w2-0";
export var table = "_w2-2";
export var tableWrapper = "_w2-1";